import React from "react";
import { useLocation } from "react-router-dom";

import AuthorForm from "./AuthorForm";
import { SummaryCard } from "../../../components/SummaryCard";
import { useRequestProcessor } from "../../../hooks/useRequestProcessors";
import { getKey, MODULE_KEYS } from "../../../api/api.keys";
import { GetAuthorById } from "../../../api/api.service";
import { hasData } from "../../../utils/commonUtils";
import { LoaderFallbackUI } from "../../../components/LoaderFallbackUI";

const UpdateAuthor = () => {
    const location = useLocation();

    let { useFetch } = useRequestProcessor();

    const id = location?.pathname?.split("/").pop() || 0;

    const {
        data,
        isLoading: isGoalDetailsLoading,
        isFetching
    } = useFetch(
        getKey([MODULE_KEYS.Author_DETAILS], { id }),
        async ({ signal }) =>
            await GetAuthorById({
                id
            })
    );

    if (isFetching || isGoalDetailsLoading || !hasData(data)) {
        return (
            <div style={{ height: "70vh" }}>
                <LoaderFallbackUI isLoader={isFetching} className={"h-100"} />
            </div>
        );
    }

    return (
        <div className="page-content">
            <SummaryCard>
                <AuthorForm mode="edit" data={data} />
            </SummaryCard>
        </div>
    );
};

export default UpdateAuthor;
